import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { DropdownMenu } from '@dtx-company/shared-components/src'
import { FlowcodeDownloadOptionMimeType } from '@dtx-company/inter-app/src/types/flowcode'
import { Menu } from '@dtx-company/shared-components/src/components/atoms/Menu/index'
import { MenuItem } from '@dtx-company/shared-components/src/components/atoms/MenuItem/index'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { setDownloadFileType } from '../../../redux/slices/createFlowcodeSlice'
import { useCreateFlowcodeState } from '../../../hooks/useCreateFlowcodeState'
import { useDispatch } from 'react-redux'
import React, { useState } from 'react'

const fileTypes = [
  FlowcodeDownloadOptionMimeType.PNG,
  FlowcodeDownloadOptionMimeType.JPG,
  FlowcodeDownloadOptionMimeType.SVG
]

export const FileTypeSelect = (): JSX.Element => {
  const dispatch = useDispatch()
  const { downloadFileType } = useCreateFlowcodeState()
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  return (
    <DropdownMenu
      header={
        <Box paddingLeft={'8px'} width="100%" minWidth="95px" data-testid={`selected-fileType`}>
          <Box width={'100%'} alignItems="center" padding={'10px 0 10px 5px'}>
            <Text fontSize={'14px'} lineHeight="16px" color={'inherit'} variant={'button/pageNav'}>
              {downloadFileType.toUpperCase()}
            </Text>
          </Box>
        </Box>
      }
      backgroundColor="primary.flowBlue"
      activeBackgroundColor="#E1E8FB"
      activeColor="primary.flowBlue"
      color="primary.white"
      position={'relative'}
      wrapperProps={{
        borderRadius: isDropdownOpen ? '0 4px 0 0' : '0 4px 4px 0'
      }}
      height="44px"
      borderRadius={isDropdownOpen ? '0 4px 0 0' : '0 4px 4px 0'}
      border={'none'}
      toggleArrowProps={{ right: '21px' }}
      boxShadow={isDropdownOpen ? '0 0 8px 2px rgba(0, 0, 0, 0.05)' : 'none'}
      onOpen={setIsDropdownOpen.bind(this, true)}
      onClose={setIsDropdownOpen.bind(this, false)}
    >
      <Menu
        backgroundColor={'primary.white'}
        width="100%"
        position={'absolute'}
        zIndex={1}
        borderRadius={'0 0 4px 4px'}
        boxShadow="0 4px 8px 2px rgba(0, 0, 0, 0.05)"
      >
        {fileTypes
          .filter(fileType => {
            return fileType !== downloadFileType
          })
          .map(fileType => (
            <MenuItem
              data-heap-id={`FileTypeSelect${fileType}_Button`}
              onClick={() => {
                dispatch(setDownloadFileType(fileType))
              }}
              key={fileType}
              padding={'10px 10px 10px 13px'}
              data-testid={`item-${fileType}`}
              color="primary.black"
            >
              <Text
                fontSize={'14px'}
                lineHeight="16px"
                color={'inherit'}
                variant={'button/pageNav'}
              >
                {fileType.toUpperCase()}
              </Text>
            </MenuItem>
          ))}
      </Menu>
    </DropdownMenu>
  )
}
